export default [
  {
    title: 'تنظیمات عمومی',
    icon: 'bx bxs-dashboard',
    children: [
      {
        title: 'اسلایدرهای محصول',
        route: { name: 'productslider' },
        resource: 'ProductSliderManager',
        action: 'show',
      },
      {
        title: 'تیکت ها',
        route: { name: 'ticket' },
        resource: 'TicketManager',
        action: 'show',
      },
      {
        title: 'خبرنامه',
        route: { name: 'newsletter' },
        resource: 'NewsletterManager',
        action: 'show',
      },
      {
        title: 'منو',
        route: { name: 'menu' },
        resource: 'MenuManager',
        action: 'show',
      },

      // {
      //   title: 'سوالات متداول',
      //   route: { name: 'faq' },
      //   resource: 'FaqManager',
      //   action: 'show',
      // },
      // {
      //   title: 'دسته بندی سوال',
      //   route: { name: 'faqcategory' },
      //   resource: 'FaqManager',
      //   action: 'show',
      // },
      // {
      //   title: 'بیماری ها',
      //   route: { name: 'sickness' },
      //   resource: 'SicknessManager',
      //   action: 'show',
      // },
      // {
      //   title: 'دسته بندی بیماری',
      //   route: { name: 'sicknesscategory' },
      //   resource: 'SicknessManager',
      //   action: 'show',
      // },
      {
        title: 'لینک ها',
        route: { name: 'urlmap' },
        resource: 'UrlMapManager',
        action: 'show',
      },
      {
        title: 'تاریخچه',
        route: { name: 'companyhistory' },
        resource: 'ContentManager',
        action: 'show',
      },
      {
        title: 'محتواها',
        route: { name: 'content' },
        resource: 'ContentManager',
        action: 'show',
      },
      // {
      //   title: 'ورژن ها',
      //   route: { name: 'version' },
      //   resource: 'VersionManager',
      //   action: 'show',
      // },
      {
        title: 'نظرهای مشتریان',
        route: { name: 'opinion' },
        resource: 'OpinionManager',
        action: 'show',
      },
      {
        title: 'استان ها',
        route: { name: 'state' },
        resource: 'StateManager',
        action: 'show',
      },
      {
        title: 'شهرها',
        route: { name: 'city' },
        resource: 'CityManager',
        action: 'show',
      },
      {
        title: 'تنظیمات سایت',
        route: { name: 'sitesetting' },
        resource: 'SiteSettingManager',
        action: 'show',
      },
    ],
  },
  {
    title: 'مدیریت خدمات',
    route: { name: 'duty' },
    resource: 'DutyManager',
    action: 'show',
  },
  {
    title: 'مدیریت نمایشگاه ها',
    route: { name: 'exhibition' },
    resource: 'ExhibitionManager',
    action: 'show',
  },
  {
    title: 'مدیریت بروشورها',
    route: { name: 'brochure' },
    resource: 'BrochureManager',
    action: 'show',
  },
]
